<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="affectedModal" tabindex="-1" role="dialog" aria-labelledby="affectedModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5><b>Affected {{ type }}s</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table v-if="type=='node'"  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Node Name</b></th>
                <th><b>Total Outages</b></th>

              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in nodesData" :key="index">
                <td></td>
                <td>{{row.id}}</td>
                <td>{{row.count}}</td>
              </tr>
              </tbody>
            </table>
            <table v-else  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Rack</b></th>
                <th><b>Nodes</b></th>
                <th><b>Total Outages</b></th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in (racksData)" :key="index">
                <td></td>
                <td>{{row.id}}</td>
                <td>
                  <div class="node-tags">
                    <span v-for="node in uniqueNodes(row.nodes)" :key="node.name" class="node-tag">
                      {{ node.name }}<span class="node-count">{{ node.count }}</span>
                    </span>
                  </div>
                </td>
                <td>{{row.count}}</td>
              </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "affectedNodesAndRacks",
  data(){
    return {
      nodesData: [],
      racksData: [],
      type: ''
    }
  },
  methods: {
    uniqueNodes(nodes) {
      const counts = {}
      ;(nodes || []).filter(n => n && n !== '*UNKNOWN*').forEach(n => {
        counts[n] = (counts[n] || 0) + 1
      })
      return Object.entries(counts).map(([name, count]) => ({ name, count }))
    },
    async load(dataArray, nodes, type){
      this.type=type
      this.nodesData=[]
      this.racksData=[]
      console.log('data', dataArray)
      if(type==='node'){
        dataArray.map(el => {
          this.nodesData.push({id: el.id, count: el.count, ...nodes[`${el.id}`]})
        })
      } else {
        const groupedRacks = {};
        // dataArray.forEach((item) => {
        //   const rackName = item.id
        //   if (!rackName) return
        //   if (!groupedRacks[rackName]) {
        //     groupedRacks[rackName] = { name: rackName, count: item.count }
        //   } else {
        //     groupedRacks[rackName].count += item.count
        //   }
        // });
        this.racksData = dataArray.filter(el => el)
      }
      $('#affectedModal').modal('show');
    }
  }
}
</script>

<style scoped>
.node-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}
.node-tag {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 12px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  padding: 2px 0 2px 8px;
}
.node-count {
  background: #475569;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 0 3px 3px 0;
  line-height: 1.8;
}
</style>
